import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'

import * as rotativeInventoryActions from 'action/rotativeInventory'
import * as reportActions from 'action/report'

import Checkbox from 'component/Checkbox/newCheckbox'

import CommonReport from 'component/commonReport/CommonReport'
import columns from 'component/rotativeInventoryNew/columns'
import { renderToastWarn } from 'utils/ToastUtils'
import applyMask from 'component/report/utils/Formatter'
import moment from 'moment'

class TotalAccuracy extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      formData: {},
      includeLot: false,
      updateReport: false,
    }
  }

  static propTypes = {
    auth: PropTypes.object.isRequired,
    v2fetchRotativeInventory: PropTypes.func,
    error: PropTypes.object,
    count: PropTypes.number.isRequired,
    records: PropTypes.array.isRequired,
    fetchReports: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
  }

  get formFields() {
    const { translate } = this.props

    return [
      {
        type: 'branchs',
        name: 'idBranches',
        label: translate('field.store'),
        help_text: translate('totalAccuracy.store'),
        required: true,
      },
      {
        type: 'sections',
        name: 'lsSections',
        help_text: translate('irc.choose-section'),
        label: translate('section'),
        required: false,
      },
      {
        type: 'text',
        name: 'cdLm',
        help_text: translate('mobile.hint.lm'),
        label: translate('field.lm.hint'),
        required: false,
        attrs: {
          maxLength: 8,
          minLength: 8,
          mask: '99999999',
        },
      },
      {
        type: 'date_range',
        name: 'dtPeriod',
        label: translate('field.period.hint'),
        help_text: translate('totalAccuracy.dtYear.filter'),
        required: true,
      },
    ]
  }

  get columns() {
    const { includeLot } = this.state
    const { translate } = this.props

    return columns.reduce((reduced, col, idx) => {
      const { field, fixed, headerLabel, align, customWidth, render } = col
      if (!render || (idx === 5 && !includeLot)) return reduced
      reduced[field] = {
        fixed,
        align,
        customWidth,
        disableOrer: false,
        label: translate(headerLabel),
      }
      return reduced
    }, {})
  }

  get rows() {
    const { includeLot } = this.state
    const { records, translate } = this.props

    return (records || []).map((record) =>
      columns.reduce((reduced, col, idx) => {
        const { type, render, field, headerLabel } = col
        if (!render || (idx === 5 && !includeLot)) return reduced
        reduced[field] =
          record[field] || record[field] === 0
            ? applyMask(type, record[field], translate, headerLabel, record.numHouses)
            : '-'
        return reduced
      }, {})
    )
  }

  onSubmit = (data, successCallback) => {
    const { includeLot } = this.state
    const {
      error,
      v2fetchRotativeInventory,
      auth: {
        user: { dsToken },
      },
    } = this.props

    const [dtStart, dtEnd] = data.dtPeriod
    data = {
      ...data,
      includeLot: includeLot ? 1 : 0,
      dtStart: moment(dtStart).format('DD/MM/YYYY'),
      dtEnd: moment(dtEnd).format('DD/MM/YYYY'),
      size: 10,
      limit: 10,
      hasPagination: true,
    }

    this.setState({ formData: data, updateReport: false })
    delete data.dtPeriod

    v2fetchRotativeInventory(dsToken, data).then(() => {
      if (error) {
        renderToastWarn(error)
        return
      }

      successCallback({
        data: this.rows,
        total: this.props.count,
      })
    })
  }

  onExport = (successCallback) => {
    const { formData } = this.state
    const {
      fetchReports,
      auth: {
        user: { dsToken },
      },
    } = this.props

    fetchReports(dsToken, { tpReport: 9 }, formData).then(() =>
      successCallback(true)
    )
  }

  render() {
    const { translate } = this.props
    const { updateReport } = this.state

    return (
      <CommonReport
        translate={translate}
        title={translate('rotativeInventory.stockCounting.title')}
        onSubmit={this.onSubmit}
        fields={this.formFields}
        columns={this.columns}
        onExport={this.onExport}
        update={updateReport}
        emptyReportMsg='totalAccuracy.return.filter'
        topLeftPart={() => (
          <Checkbox
            label={translate('rotativeInventory.showBatch')}
            onChange={(e) => {
              this.setState({
                includeLot: e,
                updateReport: true,
              })
            }}
          />
        )}
      />
    )
  }
}

const mapStateToProps = ({
  rotativeInventoryReducer,
  paginateReducer,
  reportReducer,
}) => ({
  count: paginateReducer.count,
  current: paginateReducer.current,
  error: reportReducer.get.error,
  pages: paginateReducer.pages,
  records: rotativeInventoryReducer.records,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...rotativeInventoryActions, ...reportActions },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(TotalAccuracy)
)
